
import Vue from "vue";

export default Vue.extend({
  name: "StatusReferenceValues",
  data: () => ({
    menu: false
  })
});
